/**
 * Web Component: collection-promo-banner
 * Banner promocional que se inyecta en el grid de productos Klevu.
 * Atributos: image, image-mobile, video, video-mobile, poster, url, banner-ref
 * Origen de datos: metaobjeto de Shopify o Bloomreach Engagement (window.KCPromoBanners)
 */
(function () {
  const tag = 'collection-promo-banner';

  if (customElements.get(tag)) return;

  const reduceMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Una vista por banner por pageview: la reinyeccion del grid (filtros,
  // paginacion, resize) no debe inflar la metrica.
  const trackedViews = {};

  function trackEngagement(event, payload) {
    try {
      if (typeof window.exponea !== 'undefined' && typeof window.exponea.track === 'function') {
        window.exponea.track(event, payload);
      }
    } catch (e) {}
  }

  // Panel visible en pantalla para diagnosticar en dispositivos reales sin
  // acceso a devtools remoto (ej. iPhone sin Mac). Se activa solo con
  // ?kcdebug=1 en la URL, nunca corre para un visitante normal.
  const debugEnabled = /[?&]kcdebug=1/.test(location.search);

  // Toggle temporal para comparar object-fit: cover vs contain en vivo sin
  // redeploy. Solo para pruebas via URL, no es una opcion de producto.
  const forceCover = /[?&]kccover=1/.test(location.search);
  function debugPanel(video) {
    if (!debugEnabled) return;
    const box = document.createElement('div');
    box.style.cssText =
      'position:fixed;bottom:0;left:0;right:0;z-index:999999;' +
      'background:rgba(0,0,0,0.9);color:#0f0;font:11px/1.4 monospace;' +
      'padding:8px;max-height:40vh;overflow:auto;white-space:pre-wrap;';
    document.body.appendChild(box);

    function render(evt) {
      const wrap = video.closest('.kuBannerImgWrap');
      const r = wrap ? wrap.getBoundingClientRect() : null;
      box.textContent =
        '[' + (evt || 'poll') + '] ' + new Date().toLocaleTimeString() + '\n' +
        'src: ' + video.currentSrc + '\n' +
        'videoWidth/Height: ' + video.videoWidth + 'x' + video.videoHeight + '\n' +
        'readyState: ' + video.readyState + ' (4=listo)\n' +
        'networkState: ' + video.networkState + ' (1=cargando,2=nada,3=sin fuente)\n' +
        'paused: ' + video.paused + ' | ended: ' + video.ended + ' | muted: ' + video.muted + '\n' +
        'currentTime: ' + video.currentTime.toFixed(2) + '\n' +
        'error: ' + (video.error ? video.error.code + ' ' + video.error.message : 'ninguno') + '\n' +
        'celda: ' + (r ? Math.round(r.width) + 'x' + Math.round(r.height) : 'sin celda') + '\n' +
        'objectFit: ' + getComputedStyle(video).objectFit + '\n' +
        'display: ' + getComputedStyle(video).display + ' | visibility: ' + getComputedStyle(video).visibility + '\n' +
        'opacity: ' + getComputedStyle(video).opacity + ' | z-index: ' + getComputedStyle(video).zIndex;
    }

    ['loadstart', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough',
     'playing', 'pause', 'waiting', 'stalled', 'suspend', 'error', 'emptied']
      .forEach((evt) => video.addEventListener(evt, () => render(evt)));

    render('inicial');
    setInterval(() => render(), 1000);
  }

  // Igual que debugPanel pero para <img>, mas una miniatura de referencia sin
  // ningun CSS del grid encima (para comparar contra lo que se ve estirado).
  function debugPanelImg(img) {
    if (!debugEnabled) return;
    const box = document.createElement('div');
    box.style.cssText =
      'position:fixed;bottom:0;left:0;right:0;z-index:999999;' +
      'background:rgba(0,0,0,0.9);color:#0ff;font:11px/1.4 monospace;' +
      'padding:8px;max-height:55vh;overflow:auto;white-space:pre-wrap;';
    document.body.appendChild(box);

    const info = document.createElement('div');
    box.appendChild(info);

    const label = document.createElement('div');
    label.textContent = '--- miniatura sin CSS del grid, tal cual el archivo ---';
    label.style.margin = '6px 0 4px';
    box.appendChild(label);

    const ref = document.createElement('img');
    ref.src = img.src;
    ref.style.cssText = 'max-width:140px;max-height:45vh;display:block;border:1px solid #0ff;';
    box.appendChild(ref);

    function render(evt) {
      const wrap = img.closest('.kuBannerImgWrap');
      const r = wrap ? wrap.getBoundingClientRect() : null;
      const ir = img.getBoundingClientRect();
      const wrapH = r ? Math.round(r.height) : null;
      const wrapHComputed = wrap ? getComputedStyle(wrap).height : null;
      const hermanosEls = wrap ? Array.from(wrap.querySelectorAll('img, video')) : [];
      var txt =
        '[IMG ' + (evt || 'poll') + '] ' + new Date().toLocaleTimeString() + '\n' +
        'celda(wrap) rect: ' + (r ? Math.round(r.width) + 'x' + wrapH : 'sin celda') + '\n' +
        'celda(wrap) computed height: ' + wrapHComputed + '\n' +
        'total hermanos: ' + hermanosEls.length + '\n';
      hermanosEls.forEach(function (el, i) {
        var er = el.getBoundingClientRect();
        var cs = getComputedStyle(el);
        txt += '--- hermano ' + i + ' (' + el.tagName + '.' + el.className + ') ---\n' +
          '  esEsteElemento: ' + (el === img) + '\n' +
          '  src: ...' + (el.currentSrc || el.src || '').slice(-45) + '\n' +
          '  rect: ' + Math.round(er.width) + 'x' + Math.round(er.height) +
            ' @ (' + Math.round(er.left) + ',' + Math.round(er.top) + ')\n' +
          '  display: ' + cs.display + ' | height(computed): ' + cs.height + '\n';
      });

      // Cadena completa de ancestros: para encontrar en que nivel se corta
      // la herencia del height:100% (percentage height requiere que TODOS
      // los ancestros tengan una altura definida, no solo el inmediato).
      txt += '=== cadena de ancestros (height computado) ===\n';
      var node = img;
      var depth = 0;
      while (node && depth < 8) {
        var ncs = getComputedStyle(node);
        var tag = node.tagName ? node.tagName.toLowerCase() : '#doc';
        var cls = node.className ? '.' + String(node.className).replace(/\s+/g, '.') : '';
        txt += depth + ': <' + tag + cls + '> height=' + ncs.height +
          ' display=' + ncs.display + ' position=' + ncs.position + '\n';
        if (node.tagName === 'LI') break;
        node = node.parentElement;
        depth++;
      }

      info.textContent = txt;
    }

    ['load', 'error'].forEach((evt) => img.addEventListener(evt, () => render(evt)));
    render('inicial');
    setInterval(() => render(), 1000);
  }

  class CollectionPromoBanner extends HTMLElement {
    static get observedAttributes() {
      return ['image', 'image-mobile', 'video', 'video-mobile', 'poster', 'url', 'banner-ref'];
    }

    constructor() {
      super();
      this._image = '';
      this._imageMobile = '';
      this._video = '';
      this._videoMobile = '';
      this._poster = '';
      this._url = '#';
      this._bannerRef = 'banner';
      this._observer = null;
      this._mediaCount = 0;
      this._failCount = 0;
    }

    connectedCallback() {
      this._render();
      this._attachClickHandler();
    }

    disconnectedCallback() {
      this._disconnectObserver();
    }

    attributeChangedCallback(name, _old, value) {
      const val = value || '';
      if (name === 'image') this._image = val;
      if (name === 'image-mobile') this._imageMobile = val;
      if (name === 'video') this._video = val;
      if (name === 'video-mobile') this._videoMobile = val;
      if (name === 'poster') this._poster = val;
      if (name === 'url') this._url = value || '#';
      if (name === 'banner-ref') this._bannerRef = value || 'banner';
      if (this.isConnected) {
        this._render();
        this._attachClickHandler();
      }
    }

    _disconnectObserver() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    _hideCell() {
      const li = this.closest('li.klevuBanner');
      if (li) li.style.display = 'none';
    }

    // Solo se oculta la celda si TODAS las piezas fallaron: con desktop+mobile
    // el navegador igual descarga la pieza oculta y un 404 no debe matar el banner.
    _onMediaError() {
      this._failCount++;
      if (this._failCount >= this._mediaCount) this._hideCell();
    }

    _createImg(src, className) {
      const img = document.createElement('img');
      img.src = src || '';
      img.alt = '';
      // 'eager', no 'lazy': el banner se inserta dinamicamente despues del
      // render inicial del grid, y el lazy-load nativo puede no detectar
      // que ya esta en pantalla en ese caso (mas inconsistente en WebKit).
      img.loading = 'eager';
      img.className = className;
      img.onerror = () => this._onMediaError();
      debugPanelImg(img);
      return img;
    }

    _createVideo(src, className) {
      const video = document.createElement('video');
      video.className = className;
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      video.disablePictureInPicture = true;
      // 'auto' (no 'metadata'): en mobile con datos moviles o ahorro de
      // bateria, el autoplay puede demorar o bloquearse; con 'metadata' el
      // navegador ni siquiera baja el primer frame mientras tanto, dejando
      // la celda en gris. Con 'auto' al menos hay un frame visible de inmediato.
      video.preload = 'auto';
      // Los atributos son obligatorios ademas de las propiedades: iOS/Safari
      // solo respetan el autoplay silenciado si vienen en el markup.
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('aria-hidden', 'true');
      if (this._poster) video.poster = this._poster;
      video.onerror = () => this._onMediaError();
      video.src = src;

      if (!reduceMotion) {
        video.autoplay = true;
        video.setAttribute('autoplay', '');
      }
      if (forceCover) video.style.objectFit = 'cover';
      debugPanel(video);
      return video;
    }

    _createMedia(videoSrc, imageSrc, videoClass, imageClass) {
      if (videoSrc) {
        this._mediaCount++;
        return this._createVideo(videoSrc, videoClass);
      }
      if (imageSrc) {
        this._mediaCount++;
        return this._createImg(imageSrc, imageClass);
      }
      return null;
    }

    _render() {
      this._disconnectObserver();
      this._mediaCount = 0;
      this._failCount = 0;

      const hasDesktop = this._video || this._image;
      const hasMobile = this._videoMobile || this._imageMobile;

      if (!hasDesktop && !hasMobile) {
        this.innerHTML = '';
        this._hideCell();
        return;
      }

      const wrap = document.createElement('div');
      wrap.className = 'kuProdWrap kuBannerWrap';

      const imgWrap = document.createElement('div');
      imgWrap.className = 'kuBannerImgWrap';

      // Sin URL real, el banner no debe ser clickeable. El default del
      // template parameter en Bloomreach es '#' (no vacio) si el marketer
      // no carga link, asi que ambos casos cuentan como "sin link".
      const hasLink = !!this._url && this._url !== '#';
      const a = document.createElement(hasLink ? 'a' : 'div');
      if (hasLink) {
        a.href = this._url;
        a.target = '_self';
        a.className = 'klevuBannerClick';
      } else {
        a.className = 'klevuBannerStatic';
      }
      a.setAttribute('data-name', this._bannerRef);
      a.setAttribute('aria-label', 'Banner promocional');

      // Una sola pieza en el DOM, elegida aqui en JS segun el viewport actual
      // en vez de crear las dos y dejar que el CSS oculte una: en WebKit real
      // (iOS) confirmamos que el display:none de la media query no siempre
      // se aplica a tiempo sobre un elemento recien insertado por JS, y las
      // dos piezas quedan apiladas visualmente.
      const isMobileViewport =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(max-width: 768px)').matches;

      let only;
      if (isMobileViewport && hasMobile) {
        only = this._createMedia(this._videoMobile, this._imageMobile, '', '');
      } else if (hasDesktop) {
        only = this._createMedia(this._video, this._image, '', '');
      } else {
        only = this._createMedia(this._videoMobile, this._imageMobile, '', '');
      }
      if (only) a.appendChild(only);

      imgWrap.appendChild(a);
      wrap.appendChild(imgWrap);

      this.innerHTML = '';
      this.appendChild(wrap);

      this._observeVisibility();
    }

    // Un solo observer para las dos cosas que dependen del viewport:
    // reproducir/pausar el video y contar la vista.
    _observeVisibility() {
      if (typeof IntersectionObserver !== 'function') {
        this._playVideos();
        this._trackView();
        return;
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this._playVideos();
              this._trackView();
            } else {
              this._pauseVideos();
            }
          });
        },
        { threshold: 0.25 }
      );

      this._observer.observe(this);
    }

    _playVideos() {
      if (reduceMotion) return;
      const videos = this.querySelectorAll('video');
      for (let i = 0; i < videos.length; i++) {
        const promise = videos[i].play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      }
    }

    _pauseVideos() {
      const videos = this.querySelectorAll('video');
      for (let i = 0; i < videos.length; i++) videos[i].pause();
    }

    _trackView() {
      const ref = this._bannerRef || 'banner';
      if (trackedViews[ref]) return;
      trackedViews[ref] = true;
      trackEngagement('plp_banner_view', {
        banner_ref: ref,
        banner_url: this._url,
        has_video: !!(this._video || this._videoMobile),
        location: window.location.pathname,
      });
    }

    _attachClickHandler() {
      const link = this.querySelector('.klevuBannerClick');
      if (!link || link.dataset.attached === 'true') return;

      link.dataset.attached = 'true';
      link.addEventListener('click', () => {
        const ref = link.getAttribute('data-name') || 'banner';

        // Klevu analytics: se mantiene mientras el PLP siga corriendo sobre Klevu.
        const trackingUrl =
          'https://stats.ksearchnet.com/analytics/datatracking?type=banner&klevu_bannerid=' +
          encodeURIComponent(ref) +
          '&klevu_term=*&klevu_request=click';
        new Image().src = trackingUrl;

        trackEngagement('plp_banner_click', {
          banner_ref: ref,
          banner_url: link.href,
          location: window.location.pathname,
        });
      });
    }
  }

  customElements.define(tag, CollectionPromoBanner);
})();
